import { createActions } from 'redux-actions';
import { postSendMail } from '@/apis';

export default createActions({
  postSendMail: async (name, email, content) =>
    postSendMail(name, email, content),
});
